'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base64Img = require('base64-img');

var _base64Img2 = _interopRequireDefault(_base64Img);

var _UploadGallery = require('./UploadGallery');

var _UploadGallery2 = _interopRequireDefault(_UploadGallery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UploadGalleryContainer = function (_Component) {
  _inherits(UploadGalleryContainer, _Component);

  function UploadGalleryContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UploadGalleryContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadGalleryContainer.__proto__ || Object.getPrototypeOf(UploadGalleryContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      base64: {},
      tiles: []
    }, _this.handleOnDragEnd = function (result) {
      var handleImageChangePosition = _this.props.handleImageChangePosition;
      var tiles = _this.state.tiles;

      if (!result.destination) {
        return;
      }

      var reorderedImages = _this.reorder(tiles, result.source.index, result.destination.index);

      handleImageChangePosition && handleImageChangePosition(reorderedImages);

      _this.setState({
        tiles: reorderedImages
      });
    }, _this.updateBase64 = function (_ref2) {
      var children = _ref2.children,
          prevChildren = _ref2.prevChildren;
      var isLengthChanged = children.length > 0 && prevChildren.length !== children.length;

      if (isLengthChanged) {
        _react2.default.Children.forEach(children, function (child) {
          child.props && child.props.url && _base64Img2.default.requestBase64(child.props.url, function (err, res, body) {
            _this.setState({
              base64: _extends({}, _this.state.base64, _defineProperty({}, child.props.url, body))
            });
          });
        });
      }

      var oldProps = _react2.default.Children.map(prevChildren, function (_ref3) {
        var children = _ref3.children,
            child = _objectWithoutProperties(_ref3, ['children']);

        return _extends({}, child.props);
      });

      var props = _react2.default.Children.map(children, function (_ref4) {
        var children = _ref4.children,
            child = _objectWithoutProperties(_ref4, ['children']);

        return _extends({}, child.props);
      });

      if (isLengthChanged || JSON.stringify(oldProps) !== JSON.stringify(props)) {
        _this.setState({
          tiles: children
        });
      }
    }, _this.handleGetListStyle = function (isDraggingOver) {
      var isDraggable = _this.props.isDraggable;
      return isDraggable ? {
        display: 'flex',
        overflow: 'hidden',
        overflowX: 'auto',
        margin: '0px -25px 0px 0px',
        width: '100%',
        height: '190px'
      } : {
        margin: '0px -25px 0px 0px',
        width: '100%'
      };
    }, _this.handleGetItemStyle = function (isDragging, draggableStyle) {
      return _extends({
        userSelect: 'none'
      }, draggableStyle);
    }, _this.reorder = function (list, startIndex, endIndex) {
      var result = Array.from(list);

      var _result$splice = result.splice(startIndex, 1),
          _result$splice2 = _slicedToArray(_result$splice, 1),
          removed = _result$splice2[0];

      result.splice(endIndex, 0, removed);
      return result;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UploadGalleryContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var children = this.props.children;
      var prevChildren = [];
      this.updateBase64({
        children: children,
        prevChildren: prevChildren
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var children = this.props.children;
      var prevChildren = prevProps.children;
      this.updateBase64({
        children: children,
        prevChildren: prevChildren
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_UploadGallery2.default, _extends({}, this.props, this.state, {
        handleGetListStyle: this.handleGetListStyle,
        handleGetItemStyle: this.handleGetItemStyle,
        handleOnDragEnd: this.handleOnDragEnd
      }));
    }
  }]);

  return UploadGalleryContainer;
}(_react.Component);

exports.default = UploadGalleryContainer;
module.exports = exports.default;